export default __webpack_public_path__ + "static/media/question.e993eb57.svg";